import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-chem-soft/80 px-5 py-8" data-id="element-244" data-mp="hr1ily8m9jdr">
      <div className="mx-auto max-w-3xl text-center" data-id="element-245" data-mp="1c0duxxyuun3j">
        <p className="text-sm font-medium text-chem-deep sm:text-base" data-id="element-246" data-mp="1c28eb7uha75i">
          Materiały po polsku • Gotowe do druku • Dla klas 7–8, liceum i technikum
        </p>
      </div>
    </section>;
}